module.exports = __webpack_public_path__ + "img/img4.d6ce11d2.png";